module.exports = __webpack_public_path__ + "img/31.75e5379e.jpg";